import React from 'react';
import { path, defaultTo, compose, is } from 'ramda';
import PropTypes from 'prop-types';

import SelectField from 'components/SelectField';

const safeValue = (obj, value) => compose(defaultTo(null), path([value]))(obj);

const StrengthSelection = ({ strengths, ...props }) => {
  const value = props.input.value;
  const onChangeStr = strValue => {
    const onChange = props.input.onChange;
    onChange && onChange({ ...value, strength: strValue });
  };

  return (
    is(Object, value) && (
      <SelectField
        {...props}
        editing={props.editing}
        input={{ value: safeValue(value, 'strength'), onChange: onChangeStr }}
        name="strength"
        hintLocale="medication.labels.chooseStrength"
        options={strengths}
        rawValues
      />
    )
  );
};

StrengthSelection.propTypes = {
  strengths: PropTypes.arrayOf([PropTypes.object]),
};

export default StrengthSelection;
